





















































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { mapGetters, mapState } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Ability } from '@/types/Ability'
import ECharts from 'vue-echarts'
import { use } from 'echarts/core'
import { GridComponent, MarkLineComponent, MarkPointComponent } from 'echarts/components';
import { LineChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import ErrorDisplay from '@/components/ErrorDisplay.vue'
import _ from 'lodash'
import { ecart_type, moyenne, quantile } from '@/utils/helpers'
import { ScopeAjustement } from '@/types/EpreuveCorrectionResultat'

use([
    GridComponent,
    LineChart,
    CanvasRenderer,
    UniversalTransition,
    MarkLineComponent,
    MarkPointComponent
])

@Component({
    computed: {
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA']),
        ...mapState('epreuveCorrectionResultat', ['notes']),
        ...mapState('ajustement', ['error'])
    },
    components: {
        'font-awesome-icon': FontAwesomeIcon,
        ECharts,
        ErrorDisplay
    }
})

export default class AjustementNotesSeuils extends Vue {
    @Prop() mode_ajustement?: string
    @Prop() show?: boolean
    @Prop() datas?: any
    @Prop() max_grade?: number
    @Prop() index_ajustement?: number
    @Prop() index_prec_ajustement?: any
    @Prop() if_test?: boolean

    Ability = Ability
    ScopeAjustement = ScopeAjustement
    option: any = null
    option_stats: any = null
    view_courbe = false
    points_trace: any= []
    points_saisis: any = []
    old_points: any = []
    av_ajustements: any = []
    ap_ajustements: any = []
    gb_ajustements: any = []
    scope_select: any = null
    waiting_process = false
    notes_rassemble: any = {
        notes: [],
        nb_candidats: 0
    }

    notes_rassemble_gb: any = {
        notes: [],
        nb_candidats: 0
    }

    stats_av : any = {
        moyenne: 0,
        ecart_type: 0,
        mediane: 0,
        ecart_interquartile: 0
    }

    stats_ap : any = {
        moyenne: 0,
        ecart_type: 0,
        mediane: 0,
        ecart_interquartile: 0
    }

    stats_global: any = {
        moyenne: 0,
        ecart_type: 0,
        mediane: 0,
        ecart_interquartile: 0
    }

    @Watch('view_courbe')
    onViewCourbeChange() {
        if (this.view_courbe) {
            this.resize_courbe()
        }
    }

    /**
     * getNamesCorrectors
     * @description Retourne le nom des correcteurs
     * @return {string}
     */
    getNamesCorrectors(): string {
        let name_correctors = ''
        let liste_correctors: Array<any> = []
        if (this.scope_select) {
            if (this.$props.mode_ajustement === ScopeAjustement.BATCH_CORRECTION) {
                liste_correctors = this.scope_select.scope.corrector_group.correctors
            } else if (this.$props.mode_ajustement === ScopeAjustement.CORRECTOR_GROUP) {
                liste_correctors = this.scope_select.scope.correctors
            }

            name_correctors = liste_correctors.map((corrector: any) => `${corrector.name} ${corrector.first_name}, `).join(', ')

            if (this.$props.mode_ajustement === ScopeAjustement.BATCH_CORRECTION) {
                name_correctors += ' - LOT ' + this.scope_select.scope_id
            }
        }

        return name_correctors
    }

    /**
     * save
     * @description Applique les ajustements choisis
     * @return {void}
     */
    save(): void {
        if (this.points_saisis.length) {
            this.waiting_process = true

            const idInfo = 't_info_' + Math.random()
            const infosToaster = {
                id: idInfo,
                toaster: 'b-toaster-top-right',
                variant: 'primary',
                noCloseButton: true,
                fade: true,
                noAutoHide: true
            }
            this.$bvToast.toast('Enregistrement en cours ...', infosToaster)

            let id_select = this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect.id
            if (this.$props.mode_ajustement !== ScopeAjustement.EPREUVE) {
                id_select = this.scope_select.id
            }

            const payload = {
                ajustement_name: this.$props.index_ajustement,
                epreuvecorrectionresultat_id: id_select,
                params: {
                    thresholds: this.points_saisis
                }
            }
            this.$store.dispatch('epreuveCorrectionResultat/saveAdjustement', {
                epreuve_correction_resultat_id: id_select,
                adjustement_id: this.$props.index_ajustement,
                payload: payload
            })
                .then(() => {
                    const idSucces = 't_succes_' + Math.random()
                    const succesToaster = {
                        id: idSucces,
                        toaster: 'b-toaster-top-right',
                        variant: 'success',
                        noCloseButton: true,
                        fade: true,
                        autoHideDelay: 5000
                    }
                    this.$bvToast.toast('Enregistrement terminé.', succesToaster)

                    this.close()
                })
                .finally(() => {
                    this.$bvToast.hide(idInfo)
                    this.waiting_process = false
                })
        }
    }

    /**
     * close
     * @description Ferme l'outil d'ajustement des notes
     * @return {void}
     */
    close(): void {
        this.$emit('close')
    }

    /**
     * create_courbe_graph
     * @description Créer le graphique de la courbe de point
     * @return {void}
     */
    create_courbe_graph(): void {
        this.option = {
            tooltip: {
                trigger: 'item',
                formatter : '{c}'
            },
            grid: {
                top: '8%'
            },
            xAxis: {
                min: 0,
                max: 20,
                type: 'value',
                splitNumber: 20,
                name: "Notes avant ajustement",
                nameLocation: "center",
                nameRotate: 0,
                nameTextStyle: {
                    padding: 10,
                    color: '#909090'
                },
                axisLine: { onZero: true },
                tooltip: true
            },
            yAxis: {
                min: 0,
                max: 20,
                type: 'value',
                splitNumber: 20,
                name: "Notes après ajustement",
                nameLocation: "center",
                nameRotate: 90,
                nameTextStyle: {
                    padding: 10,
                    color: '#016793'
                },
                axisLine: { onZero: true },
                tooltip: true
            },
            series: [
                {
                    id: 'a',
                    type: 'line',
                    smooth: false,
                    symbolSize: 10,
                    data: this.points_trace,
                    color: '#1da6ef'
                }
            ]
        }

        this.$nextTick().then(this.resize_courbe)
    }

    /**
     * resize_courbe
     * @description Redimensionne le graphique de la courbe
     * @return {Promise<void>}
     */
    async resize_courbe(): Promise<void> {
        await this.$nextTick()
        const wrapper: HTMLElement = document.getElementById('aside-ajustement-notes') as HTMLElement
        const courbe: any = this.$refs['courbe']
        if (this.view_courbe && wrapper && courbe) {
            courbe.resize({
                width: `${wrapper.clientWidth - 16}px`,
                height: '478px'
            })
        }
    }

    /**
     * create_stats_graph
     * @description Créer le graphique de la courbe de point
     * @return {void}
     */
    create_stats_graph(): void {
        const series: any = []
        series.push({
            id: 'av_ajustement',
            type: 'line',
            step: true,
            symbolSize: 0,
            data: this.av_ajustements,
            color: '#909090'
        })
        series.push({
            id: 'ap_ajustement',
            type: 'line',
            step: true,
            symbolSize: 0,
            data: this.ap_ajustements,
            color: '#016793'
        })

        if (this.$props.mode_ajustement !== ScopeAjustement.EPREUVE) {
            series.push({
                id: 'gb_ajustement',
                type: 'line',
                step: true,
                symbolSize: 0,
                data: this.gb_ajustements,
                color: '#f8bf2F'
            })
        }

        this.option_stats = {
            tooltip: {
                trigger: 'none',
                axisPointer: {
                    type: 'cross'
                }
            },
            xAxis: {
                min: 0,
                max: 20,
                type: 'value',
                splitNumber: 20,
                name: "Notes",
                nameTextStyle: {
                    padding: 15
                },
                axisLine: { onZero: true },
                tooltip: true
            },
            yAxis: {
                min: 0,
                max: 100,
                type: 'value',
                splitNumber: 10,
                name: "Proportion de candidats (%)",
                nameRotate: (window.innerWidth > 1600 ? 0 : 90),
                nameLocation: (window.innerWidth > 1600 ? 'end' : 'center'),
                nameTextStyle: {
                    padding: 15
                },
                axisLine: { onZero: true },
                axisLabel: {
                    formatter: '{value} %'
                },
                tooltip: true
            },
            series: series
        }

        this.$nextTick().then(this.resize_stats)
        this.calcul_stats()
    }

    /**
     * resize_stats
     * @description Redimensionne le graphique des statistiques
     * @return {void}
     */
    async resize_stats(): Promise<void> {
        await this.$nextTick()
        const wrapper: HTMLElement = document.getElementById('graph-ajustement-notes') as HTMLElement
        const graph_stats: any = this.$refs['graph_stats']
        if (wrapper && graph_stats) {
            graph_stats.resize({
                width: `${wrapper.clientWidth - 16}px`,
                height: `${wrapper.clientHeight > 500 ? 500 : wrapper.clientHeight - 16}px`
            })
        }
    }

    /**
     * create_global_courbe
     * @description Créer la courbe globale des correcteurs
     * @param {Array<any>} notes - Notes des candidats
     * @return {void}
     */
    create_global_courbe(notes: any): void {
        this.notes_rassemble_gb.notes = []
        // Notes triées de la plus petite à la plus grande
        const notes_tri = _.orderBy(notes, `notes["${this.$props.index_ajustement}"]`, 'asc')

        // Rassembler les mêmes notes
        for (const n in notes_tri) {
            const exist = this.notes_rassemble_gb.notes.find((nt: any) => nt.note_gb === notes_tri[n].notes[this.$props.index_ajustement])
            if (!exist) {
                this.notes_rassemble_gb.notes.push({
                    note_gb: notes_tri[n].notes[this.$props.index_ajustement],
                    nb: 1
                })
            } else {
                exist.nb++
            }
        }

        this.notes_rassemble_gb.notes = _.orderBy(this.notes_rassemble_gb.notes, 'asc')
        this.notes_rassemble_gb.nb_candidats = notes ? notes.length : 0

        let count = 0
        this.gb_ajustements.push([0, 0])

        for (const nr in this.notes_rassemble_gb.notes) {
            const note_en_cours = this.notes_rassemble_gb.notes[nr].note_gb
            count += this.notes_rassemble_gb.notes[nr].nb
            const pct = (count*100/this.notes_rassemble_gb.nb_candidats)
            this.gb_ajustements.push([note_en_cours.toFixed(2), pct.toFixed(2)])
        }

        this.gb_ajustements.push([20, 100])

        this.create_stats_graph()
        this.calcul_stats()
    }

    /**
     * rassemble_notes
     * @description Rassemble les notes des candidats
     * @param {Array<any>} notes - Notes des candidats
     * @return {void}
     */
    rassemble_notes(notes: Array<any>): void {
        this.notes_rassemble.notes = []
        // Notes triées de la plus petite à la plus grande
        const notes_tri = _.orderBy(notes, `notes["${this.$props.index_ajustement}"]`, 'asc')


        // Rassembler les mêmes notes
        for (const n in notes_tri) {
            const note_prec = this.$props.index_prec_ajustement ? notes_tri[n].notes[this.$props.index_prec_ajustement] : notes_tri[n].note_brute
            const exist = this.notes_rassemble.notes.find((nt: any) => nt.note_av === note_prec)
            if (!exist) {
                this.notes_rassemble.notes.push({
                    note_av: note_prec,
                    note_ap: notes_tri[n].notes[this.$props.index_ajustement],
                    nb: 1
                })
            } else {
                exist.nb++
            }
        }

        this.notes_rassemble.notes = _.orderBy(this.notes_rassemble.notes, 'asc')
        this.notes_rassemble.nb_candidats = notes ? notes.length : 0
    }

    /**
     * replace_notes_ap
     * @description Remplace les notes ap par le rendu de simulation
     * @param {Array<any>} notes_simule - Notes simulées
     * @return {void}
     */
    replace_notes_ap(notes_simule: any): void {
        for (const ns in notes_simule) {
            const search_notes_av = this.notes_rassemble.notes.filter((nav: any) => nav.note_av === parseFloat(notes_simule[ns].origin))
            if (search_notes_av) {
                for (const s in search_notes_av) {
                    search_notes_av[s].note_ap = notes_simule[ns].adjusted
                }
            }
        }

        this.notes_rassemble.notes = _.orderBy(this.notes_rassemble.notes, 'note_ap', 'asc')
    }

    /**
     * calcul_proportions_candidats
     * @description Calcul de la proportion des candidats
     * @param {string} ligne - Ligne à calculer
     * @return {void}
     */
    calcul_proportions_candidats(ligne: string): void {
        // Check la note précédente → Si différente +1 / total notes
        let count = 0

        for (const nr in this.notes_rassemble.notes) {
            const note_en_cours = ligne === 'origin' ? this.notes_rassemble.notes[nr].note_av : this.notes_rassemble.notes[nr].note_ap
            count += this.notes_rassemble.notes[nr].nb
            const pct = (count*100/this.notes_rassemble.nb_candidats)
            if (ligne === 'origin') {
                this.av_ajustements.push([note_en_cours.toFixed(2), pct.toFixed(2)])
            } else {
                this.ap_ajustements.push([note_en_cours.toFixed(2), pct.toFixed(2)])
            }
        }

        this.create_stats_graph()
    }

    /**
     * search_next_point_origin
     * @description Cherche le point suivant avant ajustement
     * @param {any} e - Evènement
     * @return {void}
     */
    search_next_point_origin(e: any): void {
        if (e) {
            e.preventDefault()
            const index_point = e.currentTarget.attributes['data-index'].value
            if (this.old_points[index_point]) {
                const direction = e.currentTarget.attributes['data-direction'].value
                const index_note_source = this.notes_rassemble.notes.findIndex((nt: any) => nt.note_av === parseFloat(this.old_points[index_point].origin))
                if (index_note_source !== -1) {
                    const index_note = direction === 'up' ? index_note_source + 1 : index_note_source - 1
                    this.old_points[index_point].origin = this.points_saisis[index_point].origin = this.notes_rassemble.notes[index_note].note_av
                } else {
                    this.increment_points(direction, index_point, 'origin')
                }
            }
            this.simulate_notes()
        }
    }

    /**
     * increment_points
     * @description Incrémente / Décrémente les points
     * @param {string} direction - Direction
     * @param {number} index_point - Index du point
     * @param {string} type_point - Type de point
     * @return {void}
     */
    increment_points(direction: string, index_point: number, type_point: string): void {
        const increment = direction === 'up' ? 0.01 : -0.01
        this.old_points[index_point][type_point] = this.points_saisis[index_point][type_point] = Math.round((this.points_saisis[index_point][type_point] + increment) * 100) / 100

        this.simulate_notes()
    }

    /**
     * simulate_notes
     * @description Applique les seuils sur la collection de notes
     * @return {void}
     */
    simulate_notes(): void {
        if (this.points_saisis.length !== 0) {
            const epreuve_correction_id = this.$props.datas.epreuve_correction_id ? this.$props.datas.epreuve_correction_id : 0
            this.old_points = this.points_saisis
            const payload = {
                params : {
                    thresholds: this.points_saisis,
                    max_grade: this.max_grade
                }
            }

            if (this.$props.mode_ajustement !== ScopeAjustement.EPREUVE) {
                Vue.set(payload, 'scope_id', this.scope_select.id)
                Vue.set(payload, 'scope_type', this.$props.mode_ajustement)
            }

            this.$store.commit('ajustement/SET_ERROR', null)

            this.$store.dispatch('ajustement/simulateSeuils', { epreuve_correction_id: epreuve_correction_id, adjustment: this.$props.index_ajustement, payload: payload })
                .then((response) => {
                    this.replace_notes_ap(response.data)
                    this.ap_ajustements = []
                    this.calcul_proportions_candidats('adjusted')
                    this.maj_courbe_points()
                    this.calcul_stats()
                })
        }
    }

    /**
     * calcul_pct_point
     * @description Calcule le pourcentage du point
     * @param {number} point - Point
     * @return {string}
     */
    calcul_pct_point(point: number): string {
        let pct = 0
        let count_notes_seuil = 0
        const notes_seuil = this.notes_rassemble.notes.filter((nav: any) => nav.note_av <= point)
        if (notes_seuil) {
            for (const cns in notes_seuil) {
                count_notes_seuil += notes_seuil[cns].nb
            }
            pct = (count_notes_seuil * 100 / this.notes_rassemble.nb_candidats)
        }

        return pct.toFixed(1)
    }

    /**
     * add_seuil
     * @description Ajoute un point
     * @return {void}
     */
    add_seuil(): void {
        const last_point = this.points_saisis[this.points_saisis.length - 1]
        if (last_point) {
            this.points_saisis.push({ origin: (last_point.origin + 0.01), adjusted: last_point.adjusted === this.max_grade ? last_point.adjusted : (last_point.adjusted + 0.01) })
        } else {
            this.points_saisis.push({ origin: 1.00, adjusted: 2.00 })
        }
    }

    /**
     * delete_seuil
     * @description Supprime un point
     * @param {number} index - Index du point
     * @return {void}
     */
    delete_seuil(index: number): void {
        this.points_saisis.splice(index, 1)
        this.simulate_notes()
    }

    /**
     * get_libelles_concours
     * @description Retourne une chaine des noms de concours de l'épreuve
     * @param {any} concours - Concours
     * @return {string}
     */
    get_libelles_concours(concours: any): string {
        return concours.map((c: any) => c.name).join(', ')
    }

    /**
     * maj_courbe_points
     * @description Met à jour la collection de points pour le tracé de la courbe
     * @return {void}
     */
    maj_courbe_points(): void {
        this.points_trace = []
        this.points_trace.push([0.00, 0.00])

        // TODO : Voir si application d'une règle pour les points par défaut
        for (const p in this.points_saisis) {
            this.points_trace.push([
                parseFloat(this.points_saisis[p].origin),
                this.points_saisis[p].adjusted
            ])
        }

        this.points_trace.push([20.00,20.00])
        this.create_courbe_graph()
    }

    /**
     * calcul_stats
     * @description Calcule les statistiques
     * @return {void}
     */
    calcul_stats(): void {
        // Moyenne
        const array_notes_av = []
        const array_notes_ap = []
        const array_notes_gb = []

        for (const x in this.notes_rassemble.notes) {
            let t = 0
            while(t < this.notes_rassemble.notes[x].nb) {
                array_notes_av.push(this.notes_rassemble.notes[x].note_av)
                array_notes_ap.push(this.notes_rassemble.notes[x].note_ap)
                t++
            }
        }

        // Moyenne
        this.stats_av.moyenne = moyenne(array_notes_av)
        this.stats_ap.moyenne = moyenne(array_notes_ap)

        // Ecart type
        this.stats_av.ecart_type = ecart_type(array_notes_av, this.stats_av.moyenne)
        this.stats_ap.ecart_type = ecart_type(array_notes_ap, this.stats_ap.moyenne)

        // Médiane
        this.stats_av.mediane = quantile(array_notes_av, 0.5)
        this.stats_ap.mediane = quantile(array_notes_ap,0.5)

        // Ecart interquartile
        const quantile_1_av = quantile(array_notes_av, 0.25)
        const quantile_3_av = quantile(array_notes_av, 0.75)

        this.stats_av.ecart_interquartile = (quantile_3_av - quantile_1_av).toFixed(2)

        const quantile_1_ap = quantile(array_notes_ap, 0.25)
        const quantile_3_ap = quantile(array_notes_ap, 0.75)

        this.stats_ap.ecart_interquartile = (quantile_3_ap - quantile_1_ap).toFixed(2)

        if (this.$props.mode_ajustement !== ScopeAjustement.EPREUVE) {
            for (const x in this.notes_rassemble_gb.notes) {
                let t = 0
                while(t < this.notes_rassemble_gb.notes[x].nb) {
                    array_notes_gb.push(this.notes_rassemble_gb.notes[x].note_gb)
                    t++
                }
            }

            // Moyenne
            this.stats_global.moyenne = moyenne(array_notes_gb)

            // Ecart type
            this.stats_global.ecart_type = ecart_type(array_notes_gb, this.stats_global.moyenne)

            // Médiane
            this.stats_global.mediane = quantile(array_notes_gb, 0.5)

            // Ecart interquartile
            const quantile_1_gb = quantile(array_notes_gb, 0.25)
            const quantile_3_gb = quantile(array_notes_gb, 0.75)

            this.stats_global.ecart_interquartile = (quantile_3_gb - quantile_1_gb).toFixed(2)
        }

        this.$nextTick().then(this.resize_stats)
    }

    /**
     * mounted
     * @description Montage du composant
     * @return {void}
     */
    mounted(): void {
        // Récupération des points enregistrés
        if (this.$store.state.epreuveCorrectionResultat.notes) {
            const batch_correction_id = this.$store.state.epreuveCorrectionResultat.notes[0].batch_correction_id
            if (this.$props.mode_ajustement === ScopeAjustement.BATCH_CORRECTION) {
                this.scope_select = this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultats
                    .find((ep: any) => ep.scope_id === batch_correction_id && ep.scope_type === ScopeAjustement.BATCH_CORRECTION)
            } else if (this.$props.mode_ajustement === ScopeAjustement.CORRECTOR_GROUP) {
                this.scope_select = this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultats
                    .find((ep: any) => ep.scope_id === batch_correction_id && ep.scope_type === ScopeAjustement.CORRECTOR_GROUP)
            } else {
                this.scope_select = this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect
            }

            if (this.scope_select && this.scope_select.ajustements_params[this.$props.index_ajustement].params.length !== 0) {
                this.points_saisis = this.scope_select.ajustements_params[this.$props.index_ajustement].params.thresholds
            }

            this.av_ajustements = []
            this.rassemble_notes(this.$store.state.epreuveCorrectionResultat.notes)
            this.calcul_proportions_candidats('origin')
            if (this.points_saisis.length !== 0) {
                this.simulate_notes()
            } else {
                this.maj_courbe_points()
                this.calcul_stats()
            }

            this.old_points = JSON.parse(JSON.stringify(this.points_saisis))

            if (this.$props.mode_ajustement !== ScopeAjustement.EPREUVE) {
                this.create_global_courbe(this.$store.state.epreuveCorrectionResultat.notes_globales)
            }

            window.addEventListener('resize', this.resize_courbe)
            window.addEventListener('resize', this.resize_stats)
        }
    }

    /**
     * beforeUnmount
     * @description Avant démontage du composant
     * @return {void}
     */
    beforeUnmount() {
        window.removeEventListener('resize', this.resize_courbe)
        window.removeEventListener('resize', this.resize_stats)
    }
}
